import TableIcon from './component'

export default TableIcon
